import { useQuery } from '@tanstack/react-query';

import { billingClient } from 'api/billing';
import type { BillingProfileResponse } from 'api/types';
import { QueryKeys } from 'entities/billing/api/common';

const isTemporaryState = (data: BillingProfileResponse | undefined) => {
  if (!data) {
    return false;
  }

  return data.subscription_status === 'in_progress' || data.payment_status === 'processing';
};

type UseGetBillingProfileOptions = {
  enabled?: boolean;
};

export const useGetBillingProfile = ({ enabled = true }: UseGetBillingProfileOptions = {}) => {
  const query = useQuery({
    queryKey: [QueryKeys.getBillingProfile],
    queryFn: () => billingClient.getBillingProfile(),
    enabled,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    staleTime: 1000 * 30,
    refetchIntervalInBackground: true,
    refetchInterval: (query) => {
      return isTemporaryState(query.state.data) ? 5000 : false;
    },
  });

  return {
    ...query,
    isPolling: isTemporaryState(query.data) && !query.isError,
  };
};
